<template>
  <div
    id="modalFieldLibrary"
    :style="isReduceBlur ? 'background-color: rgba(255,255,255,0.9);' : ''"
    class="modal-field-library"
  >
    <div class="modal-field-title">{{ isComponent ? 'COMPONENT' : 'TOOLBOX' }}</div>

    <div class="modal-field-content">
      <!-- Input Search -->
      <div class="input-search">
        <i class="fa fa-search" />
        <input
          v-model="searchField"
          type="text"
          placeholder="Search"
          autocomplete="off"
        >
      </div>

      <!-- Field List -->
      <div class="wrap-field">
        <div
          v-for="fields in fieldsLibrary"
          :key="fields.section"
          class="field-section"
        >
          <p
            v-if="fields.section"
            class="title-section"
          >
            {{ fields.section }}
          </p>

          <!-- Skeleton Fields -->
          <j-skeleton-field-library v-if="isLoading" />

          <div
            v-else
            class="field-list"
          >
            <div
              v-for="field in fields.fields"
              v-show="hideFieldByConfig(field.type)"
              :key="field.type"
              :id="field.type"
              class="list"
              @click="selectField(field)"
            >
              <img
                :src="require(`@/assets/new-form-ui/field-icon-active/${field.type}.svg`)"
                class="field-icon field-icon-active"
              >
              <img
                :src="require(`@/assets/new-form-ui/field-icon/${field.type}.svg`)"
                class="field-icon field-icon-default"
              >
              <span>{{ field.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-field-footer">
      <button @click="$emit('close-modal')">Close</button>
    </div>
  </div>
</template>

<script>
/* eslint-disable max-len, no-param-reassign, no-plusplus */
import { mapState } from 'vuex';
import jSkeletonFieldLibrary from '@/views/experience-manager-v2/loading/jSkeletonFieldLibrary';

export default {
  components: {
    jSkeletonFieldLibrary,
  },

  props: {
    isReduceBlur: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: true,
      fieldHover: '',
      searchField: '',
      fieldLists: [
        {
          section: 'Basic',
          fields: [
            { type: 'text', name: 'Text' },
            { type: 'descriptive', name: 'Text Area' },
            { type: 'number', name: 'Number' },
            { type: 'number_decimal', name: 'Number (Decimal)' },
            { type: 'currency', name: 'Currency' },
            { type: 'currency_selection', name: 'Currency Selection' },
            { type: 'single_selection', name: 'Single Selection' },
            { type: 'multiple_selection', name: 'Multiple Selection' },
            { type: 'user_single_selection', name: 'User Selection' },
            { type: 'password', name: 'Password' },
            { type: 'toggle', name: 'Toggle' },
            { type: 'checkbox', name: 'Checkbox' },
            { type: 'radio', name: 'Radio' },
          ],
        },
        {
          section: 'Date Time',
          fields: [
            { type: 'date', name: 'Date' },
            { type: 'time', name: 'Time' },
            { type: 'date_time', name: 'Date Time' },
            { type: 'timer', name: 'Timer' },
          ],
        },
        {
          section: 'Attachment',
          fields: [
            { type: 'single_attachment', name: 'Single Attachment' },
            { type: 'attachment', name: 'Multiple Attachment' },
            { type: 'multiple_attachment_dynamic', name: 'Dynamic Attachment' },
          ],
        },
        {
          section: 'Data Connection',
          fields: [
            { type: 'relation_record', name: 'Relation Record' },
            { type: 'multiple_relation_record', name: 'Multiple Relation Record' },
            { type: 'relation_record_external_api', name: 'Relation Record External API' },
            { type: 'multiple_relation_record_external_api', name: 'Multiple Relation Record Ext API' },
          ],
        },
        {
          section: 'Others',
          fields: [
            { type: 'separator', name: 'Separator' },
            { type: 'custom_html', name: 'HTML' },
            { type: 'digital_signature', name: 'Digital Signature' },
            { type: 'code_editor', name: 'Code Editor' },
            { type: 'text_editor', name: 'Text Editor' },
            { type: 'table_group', name: 'Table Group' },
            { type: 'group', name: 'Field Group' },
            { type: 'dynamic_field', name: 'Dynamic Field' },
            { type: 'single_tags_selection', name: 'Single Tag' },
            { type: 'multiple_tags_selection', name: 'Multiple Tag' },
            { type: 'location', name: 'Maps' },
            { type: 'color', name: 'Color' },
            { type: 'slider', name: 'Slider' },
            { type: 'text_label', name: 'Text Label' },
            { type: 'progress_bar', name: 'Progress Bar' },
          ],
        },
      ],
      fieldListsGroup: [
        {
          section: 'Basic',
          fields: [
            { type: 'text', name: 'Text' },
            { type: 'descriptive', name: 'Text Area' },
            { type: 'number', name: 'Number' },
            { type: 'number_decimal', name: 'Number (Decimal)' },
            { type: 'currency', name: 'Currency' },
            { type: 'currency_selection', name: 'Currency Selection' },
            { type: 'single_selection', name: 'Single Selection' },
            { type: 'multiple_selection', name: 'Multiple Selection' },
            { type: 'user_single_selection', name: 'User Selection' },
            { type: 'toggle', name: 'Toggle' },
            { type: 'checkbox', name: 'Checkbox' },
            { type: 'radio', name: 'Radio' },
          ],
        },
        {
          section: 'Date Time',
          fields: [
            { type: 'date', name: 'Date' },
            { type: 'time', name: 'Time' },
            { type: 'date_time', name: 'Date Time' },
          ],
        },
        {
          section: 'Attachment',
          fields: [
            { type: 'single_attachment', name: 'Single Attachment' },
            { type: 'attachment', name: 'Multiple Attachment' },
            { type: 'multiple_attachment_dynamic', name: 'Dynamic Attachment' },
          ],
        },
        {
          section: 'Data Connection',
          fields: [
            { type: 'relation_record', name: 'Relation Record' },
            { type: 'multiple_relation_record', name: 'Multiple Relation Record' },
            { type: 'relation_record_external_api', name: 'Relation Record External API' },
            { type: 'multiple_relation_record_external_api', name: 'Multiple Relation Record Ext API' },
          ],
        },
        {
          section: 'Others',
          fields: [
            { type: 'separator', name: 'Separator' },
            { type: 'code_editor', name: 'Code Editor' },
            { type: 'single_tags_selection', name: 'Single Tag' },
            { type: 'multiple_tags_selection', name: 'Multiple Tag' },
            { type: 'location', name: 'Maps' },
          ],
        },
      ],
      fieldListsTableGroup: [
        {
          section: 'Basic',
          fields: [
            { type: 'text', name: 'Text' },
            { type: 'number', name: 'Number' },
            { type: 'number_decimal', name: 'Number (Decimal)' },
            { type: 'currency', name: 'Currency' },
            { type: 'currency_selection', name: 'Currency Selection' },
            { type: 'single_selection', name: 'Single Selection' },
            { type: 'multiple_selection', name: 'Multiple Selection' },
            { type: 'toggle', name: 'Toggle' },
            { type: 'checkbox', name: 'Checkbox' },
            { type: 'radio', name: 'Radio' },
          ],
        },
        {
          section: 'Date Time',
          fields: [
            { type: 'date', name: 'Date' },
            { type: 'time', name: 'Time' },
            { type: 'date_time', name: 'Date Time' },
          ],
        },
        {
          section: 'Data Connection',
          fields: [
            { type: 'relation_record', name: 'Relation Record' },
            { type: 'multiple_relation_record', name: 'Multiple Relation Record' },
            { type: 'relation_record_external_api', name: 'Relation Record External API' },
            { type: 'multiple_relation_record_external_api', name: 'Multiple Relation Record Ext API' },
          ],
        },
      ],
      fieldListsPreview: [
        {
          section: 'Basic',
          fields: [
            { type: 'text', name: 'Text' },
            { type: 'descriptive', name: 'Text Area' },
            { type: 'number', name: 'Number' },
            { type: 'number_decimal', name: 'Number (Decimal)' },
            { type: 'currency', name: 'Currency' },
            { type: 'single_selection', name: 'Single Selection' },
            { type: 'multiple_selection', name: 'Multiple Selection' },
            { type: 'user_single_selection', name: 'User Selection' },
            { type: 'checkbox', name: 'Checkbox' },
            { type: 'radio', name: 'Radio' },
          ],
        },
        {
          section: 'Date Time',
          fields: [
            { type: 'date', name: 'Date' },
            { type: 'time', name: 'Time' },
          ],
        },
        {
          section: 'Attachment',
          fields: [
            { type: 'single_attachment', name: 'Single Attachment' },
            { type: 'attachment', name: 'Multiple Attachment' },
            { type: 'multiple_attachment_dynamic', name: 'Dynamic Attachment' },
          ],
        },
        {
          section: 'Data Connection',
          fields: [
            { type: 'relation_record', name: 'Relation Record' },
            { type: 'multiple_relation_record', name: 'Multiple Relation Record' },
            { type: 'relation_record_external_api', name: 'Relation Record External API' },
            { type: 'multiple_relation_record_external_api', name: 'Multiple Relation Record Ext API' },
          ],
        },
        {
          section: 'Others',
          fields: [
            { type: 'separator', name: 'Separator' },
            { type: 'single_tags_selection', name: 'Single Tag' },
            { type: 'multiple_tags_selection', name: 'Multiple Tag' },
            { type: 'location', name: 'Maps' },
          ],
        },
      ],
      fieldListsPreviewGroup: [
        {
          section: 'Basic',
          fields: [
            { type: 'text', name: 'Text' },
            { type: 'number', name: 'Number' },
            { type: 'number_decimal', name: 'Number (Decimal)' },
            { type: 'currency', name: 'Currency' },
            { type: 'single_selection', name: 'Single Selection' },
            { type: 'multiple_selection', name: 'Multiple Selection' },
            { type: 'checkbox', name: 'Checkbox' },
            { type: 'radio', name: 'Radio' },
          ],
        },
        {
          section: 'Date Time',
          fields: [
            { type: 'date', name: 'Date' },
            { type: 'time', name: 'Time' },
          ],
        },
        {
          section: 'Data Connection',
          fields: [
            { type: 'relation_record', name: 'Relation Record' },
            { type: 'multiple_relation_record', name: 'Multiple Relation Record' },
            { type: 'relation_record_external_api', name: 'Relation Record External API' },
            { type: 'multiple_relation_record_external_api', name: 'Multiple Relation Record Ext API' },
          ],
        },
      ],
      fieldListsBulk: [
        {
          section: 'Basic',
          fields: [
            { type: 'text', name: 'Text' },
            { type: 'descriptive', name: 'Text Area' },
            { type: 'number', name: 'Number' },
            { type: 'number_decimal', name: 'Number (Decimal)' },
            { type: 'single_selection', name: 'Single Selection' },
            { type: 'multiple_selection', name: 'Multiple Selection' },
          ],
        },
        {
          section: 'Date Time',
          fields: [
            { type: 'date', name: 'Date' },
          ],
        },
        {
          section: 'Data Connection',
          fields: [
            { type: 'relation_record', name: 'Relation Record' },
            { type: 'multiple_relation_record', name: 'Multiple Relation Record' },
            { type: 'relation_record_external_api', name: 'Relation Record External API' },
            { type: 'multiple_relation_record_external_api', name: 'Multiple Relation Record Ext API' },
          ],
        },
        {
          section: 'Others',
          fields: [
            { type: 'single_tags_selection', name: 'Single Tag' },
            { type: 'multiple_tags_selection', name: 'Multiple Tag' },
          ],
        },
      ],
      fieldListsSearch: [
        {
          section: 'Basic',
          fields: [
            { type: 'text', name: 'Text' },
            { type: 'number', name: 'Number' },
            { type: 'single_selection', name: 'Single Selection' },
            { type: 'user_single_selection', name: 'User Selection' },
          ],
        },
        {
          section: 'Date Time',
          fields: [
            { type: 'date', name: 'Date' },
          ],
        },
        {
          section: 'Data Connection',
          fields: [
            { type: 'relation_record', name: 'Relation Record' },
            { type: 'multiple_relation_record', name: 'Multiple Relation Record' },
            { type: 'relation_record_external_api', name: 'Relation Record External API' },
            { type: 'multiple_relation_record_external_api', name: 'Multiple Relation Record Ext API' },
          ],
        },
        {
          section: 'Others',
          fields: [
            { type: 'single_tags_selection', name: 'Single Tag' },
            { type: 'multiple_tags_selection', name: 'Multiple Tag' },
          ],
        },
      ],
      fieldListsSearchOnExport: [
        {
          section: 'Basic',
          fields: [
            { type: 'text', name: 'Text' },
            { type: 'number', name: 'Number' },
            { type: 'single_selection', name: 'Single Selection' },
            { type: 'user_single_selection', name: 'User Selection' },
            { type: 'multiple_selection', name: 'Multiple Selection' },
          ],
        },
        {
          section: 'Date Time',
          fields: [
            { type: 'date', name: 'Date' },
          ],
        },
        {
          section: 'Data Connection',
          fields: [
            { type: 'relation_record', name: 'Relation Record' },
            { type: 'multiple_relation_record', name: 'Multiple Relation Record' },
            { type: 'relation_record_external_api', name: 'Relation Record External API' },
            { type: 'multiple_relation_record_external_api', name: 'Multiple Relation Record Ext API' },
          ],
        },
        {
          section: 'Others',
          fields: [
            { type: 'single_tags_selection', name: 'Single Tag' },
            { type: 'multiple_tags_selection', name: 'Multiple Tag' },
          ],
        },
      ],
      fieldListsSearchOnDataset: [
        {
          section: 'Basic',
          fields: [
            { type: 'text', name: 'Text' },
            { type: 'number', name: 'Number' },
            { type: 'single_selection', name: 'Single Selection' },
          ],
        },
        {
          section: 'Date Time',
          fields: [
            { type: 'date', name: 'Date' },
          ],
        },
        {
          section: 'Data Connection',
          fields: [
            { type: 'relation_record', name: 'Relation Record' },
            { type: 'multiple_relation_record', name: 'Multiple Relation Record' },
            { type: 'relation_record_external_api', name: 'Relation Record External API' },
            { type: 'multiple_relation_record_external_api', name: 'Multiple Relation Record Ext API' },
          ],
        },
      ],
      fieldListsDataset: [
        {
          section: 'Basic',
          fields: [
            { type: 'text', name: 'Text' },
            { type: 'descriptive', name: 'Text Area' },
            { type: 'number', name: 'Number' },
            { type: 'number_decimal', name: 'Number (Decimal)' },
            { type: 'currency', name: 'Currency' },
            { type: 'toggle', name: 'Toggle' },
          ],
        },
        {
          section: 'Date Time',
          fields: [
            { type: 'date', name: 'Date' },
            { type: 'time', name: 'Time' },
            { type: 'date_time', name: 'Date Time' },
          ],
        },
      ],
      fieldListsComponent: [
        {
          section: '',
          fields: [
            { type: 'single_experience_manager', name: 'Single UI' },
            { type: 'multiple_experience_manager', name: 'Multiple UI' },
          ],
        },
      ],
      fieldsLibrary: [],
    };
  },

  computed: {
    ...mapState('jStoreExperienceManagerV2', [
      'isBulk', 'isSearch', 'isDataset', 'isComponent',
      'isFieldGroup', 'isTableGroup', 'isDataPreview',
      'customField', 'typeViewSearch',
    ]),

    fields() {
      let field = null;

      if (this.isBulk) {
        field = this.fieldListsBulk;
      } else if (this.isSearch && this.typeViewSearch === 'export') {
        field = this.fieldListsSearchOnExport;
      } else if (this.isSearch && this.isDataset) {
        field = this.fieldListsSearchOnDataset;
      } else if (this.isSearch) {
        field = this.fieldListsSearch;
      } else if (this.isDataset) {
        field = this.fieldListsDataset;
      } else if (this.isComponent) {
        field = this.fieldListsComponent;
      } else if (this.isFieldGroup) {
        field = this.fieldListsGroup;
      } else if (this.isTableGroup) {
        field = this.fieldListsTableGroup;
      } else if (this.isDataPreview) {
        field = this.fieldListsPreview;
      } else if (this.isDataPreviewGroup) {
        field = this.fieldListsPreviewGroup;
      } else if (this.customField) {
        field = this.customField;
      } else {
        field = this.fieldLists;
      }

      return field;
    },
  },

  watch: {
    searchField(val) {
      if (val.length > 0) {
        const dataFields = JSON.parse(JSON.stringify(this.fields));

        dataFields.filter(fields => fields.fields.some(field => field.name.toLowerCase().includes(val.toLowerCase())));
        dataFields.forEach((fields) => {
          fields.fields = fields.fields.filter(field => field.name.toLowerCase().includes(val.toLowerCase()));
        });

        this.fieldsLibrary = dataFields;
      } else {
        this.refreshDataField();
      }
    },
  },

  created() {
    this.insertDataFields();
    setTimeout(() => {
      this.isLoading = false;
    }, 700);
  },

  methods: {
    insertDataFields() {
      if (this.isBulk) {
        this.fieldsLibrary = this.fieldListsBulk;
      } else if (this.isSearch && this.typeViewSearch === 'export') {
        this.fieldsLibrary = this.fieldListsSearchOnExport;
      } else if (this.isSearch && this.isDataset) {
        this.fieldsLibrary = this.fieldListsSearchOnDataset;
      } else if (this.isSearch) {
        this.fieldsLibrary = this.fieldListsSearch;
      } else if (this.isDataset) {
        this.fieldsLibrary = this.fieldListsDataset;
      } else if (this.isComponent) {
        this.fieldsLibrary = this.fieldListsComponent;
      } else if (this.isFieldGroup) {
        this.fieldsLibrary = this.fieldListsGroup;
      } else if (this.isTableGroup) {
        this.fieldsLibrary = this.fieldListsTableGroup;
      } else if (this.isDataPreview) {
        this.fieldsLibrary = this.fieldListsPreview;
      } else if (this.isDataPreviewGroup) {
        this.fieldsLibrary = this.fieldListsPreviewGroup;
      } else if (this.customField) {
        this.fieldsLibrary = this.customField;
      } else {
        this.fieldsLibrary = this.fieldLists;
      }
    },

    refreshDataField() {
      this.isLoading = true;
      this.insertDataFields();
      setTimeout(() => {
        this.isLoading = false;
      }, 400);
    },

    hideFieldByConfig(type) {
      if (process.env.DISABLE_CURRENCY_SELECTION === 'true') return type !== 'currency_selection';
      return true;
    },

    selectField(field) {
      this.$emit('close-modal', field);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/popup/ModalFieldLibrary.vue